<template>
    <b-modal id="imgModal" :title="title" size="lg">
        <div class="img_container">
            <img :src="'/file/getImgFile/' + fileUrl" alt="">            
        </div>
        <template #modal-footer>
            <b-button class="btn"></b-button>
        </template>
    </b-modal>

</template>

<script>

import axios from 'axios'

    export default {
        name: 'imgModal',
        props: {
            title: String,
            fileUrl: String,
        }
    }
</script>

<style>

</style>